
export enum ShipmentActionCd {
	APPLY = 'Apply',
	RESET = 'Reset',
	SAVE = 'Save',
	SUBMIT = 'Submit'}

